<template>
  <div class="aside-block" ref="aside" :class="{'mini' : slideNumber !== 0, 'transparent' : transparent}">
    <transition>
      <div class="aside-block__title" v-if="slideNumber !== 0">Выше только небо</div>
    </transition>
    
    <logo-block class="aside-block__logo"></logo-block>
  </div>
</template>

<script>
import Vue from 'vue'
import LogoBlock from './LogoBlock.vue'
import { mapState, mapMutations } from 'vuex'

export default {
  name:"AsideBlock",
  components: {
    LogoBlock
  },
  data: () => ({

  }),
  computed: {
    ...mapState(['slideNumber', 'startScreenLeft', 'slidesArray','showGallery', 'videoPopupOpened']),
    transparent() {
      return this.slidesArray[this.slideNumber] && this.slidesArray[this.slideNumber].infoBlockLeft || this.showGallery || this.videoPopupOpened
    }
  },
  mounted() {
    this.$refs.aside.addEventListener('transitionend', () => {
      if (this.slideNumber !== 0) {
        this.toggleStartScreen(true)
      }
    })
  },
  methods: {
    ...mapMutations(['toggleStartScreen']),
    minimizeLogo(evt) {
      if (evt.deltaY < 0) {
        this.$refs.aside.classList.remove('mini','fixed');
        this.toggleStartScreen(false)
      } else {
        this.$refs.aside.classList.add('mini', 'fixed');
        
        this.$refs.aside.addEventListener('transitionend', () => {
          this.$refs.aside.classList.add('fixed');
          this.toggleStartScreen(true)
        })
      }

    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../styles/tools'

.aside-block
  width 100%
  max-width 100vw
  height 100%
  background #003a5d
  display flex
  flex-direction column
  align-items center
  justify-content space-between
  transition max-width 1s ease-in-out, border-right 1s ease-in-out, background-color .3s ease-in-out
  &.transparent
    background transparent


  &.mini
    max-width 10vw
    border-right 1px solid white

    @media (max-width: 600px)
      display none
  &.fixed
    position fixed

  &__logo
    margin-top auto
    transition max-width 1s ease-in-out

    .mini &
      max-width 80%

  &__title
    margin-top 250px
    font-family GraphikLCG
    text-transform uppercase
    white-space nowrap
    font-size 25px
    color #fff
    transform rotate(-90deg)
    transition opacity .2s ease-in-out

    &.v-enter
    &.v-leave-to
      opacity 0
</style>